import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuBehaviorSubjectService {


  public changeOccured: BehaviorSubject<{
    action: string, 
    parameter: any
  } | null> = new BehaviorSubject<{
    action: string, 
    parameter: any
  } | null>(null);

  constructor() { 

  }

  inform(action: string, parameter: any): void {
      this.changeOccured.next({
        action,
        parameter
      });
  }
  
}
